import { render, staticRenderFns } from "./pickupCategoryLeader.vue?vue&type=template&id=a4a7ecf2&scoped=true"
import script from "./pickupCategoryLeader.vue?vue&type=script&lang=js"
export * from "./pickupCategoryLeader.vue?vue&type=script&lang=js"
import style0 from "./pickupCategoryLeader.vue?vue&type=style&index=0&id=a4a7ecf2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a7ecf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4a7ecf2')) {
      api.createRecord('a4a7ecf2', component.options)
    } else {
      api.reload('a4a7ecf2', component.options)
    }
    module.hot.accept("./pickupCategoryLeader.vue?vue&type=template&id=a4a7ecf2&scoped=true", function () {
      api.rerender('a4a7ecf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pickupCategoryLeader.vue"
export default component.exports